module.exports = "/packs/images/svg/ireland/facilities/e_resource~83b8299686876545f62d34d0c80cd6a8.svg";